import React, { useState,useEffect,useRef } from 'react';
import { ORG_LEAVE_CONFIGURATIONS } from '../../ApiServices/BaseURL';
import { postData,getData } from '../../ApiServices/ApiService';
import { useTheme } from '../../GlobalContext/GlobalContext';
import { logFrontendException } from '../../Utils/Exception';

const LeaveConfigurationController = (leaveConfigurationsList,onRefresh) => {
  console.log("leaveConfigurationsList",leaveConfigurationsList)
  const pageName = 'LeaveConfigurationController';
  const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;
  useEffect(() => {
    if (leaveConfigurationsList && leaveConfigurationsList?.length > 0) {
      const config = leaveConfigurationsList[0];

      const weekOffDays = config?.week_off_days || [];
      const allDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

      // ✅ Dynamically calculate working day options
      const availableWorkingDayOptions = allDays
        .filter(day => !weekOffDays.includes(day))
        .map(day => ({ label: day, value: day }));

      const selectedWorkingDays = (config.working_days || [])
        .filter(day => !weekOffDays.includes(day))
        .map(day => ({ label: day, value: day }));
  
      // Mapping field.key to config key
      const configMap = {
        workingDays: selectedWorkingDays,
        officeWorkingHours: {
          start: config.office_start_time || '',
          end: config.office_end_time || ''
        },
        weekOff: weekOffDays.map(day => ({ label: day, value: day })),
        lastWorkingDay: config.last_working_day
        ? { label: String(config.last_working_day), value: String(config.last_working_day) }
        : { label: '', value: '' },
        casualLeave: config.casual_leaves ?? '',
        sickLeave: config.sick_leaves ?? '',
        sandwichLeave: config.sandwich_leaves ?? '',
        presentDays: config.present_days ?? '',
        lossOfPay: config.loss_of_pay ?? '',
        location: config.location ?? '',
        inTime: config.in_time ?? '',
        outTime: config.out_time ?? '',
        breakTime: config.break_time ?? ''
      };
  
      const updatedFields = fields.map((field) => {
        if (field.key === 'workingDays') {
          return {
            ...field,
            value: configMap[field.key],
            options: availableWorkingDayOptions
          };
        }
        return {
          ...field,
          value: configMap[field.key] !== undefined ? configMap[field.key] : field.value
        };
      });
  
      setFields(updatedFields);
    }
  }, [leaveConfigurationsList]);

  useEffect(()=>{
    onRefresh();
  },[])

  const { setIsLoginPopup } = useTheme();
    const [errors, setErrors] = useState({
        workingDays: '',
        officeWorkingHours: '',
        weekOff: '',
        lastWorkingDay: '',
        casualLeave: '',
        sickLeave: '',
        sandwichLeave: '',
        presentDays: '',
        lossOfPay: '',
        location: '',
        inTime: '',
        outTime: '',
        breakTime: '',
      });

    const generateTimeSlots = () => {
        const times = [];
        for (let h = 0; h < 24; h++) {
          for (let m = 0; m < 60; m += 5) {
            const hour = h.toString().padStart(2, '0');
            const minute = m.toString().padStart(2, '0');
            times.push(`${hour}:${minute}`);
          }
        }
        return times;
      };

      const timeOptions = generateTimeSlots();

    //   const [fields, setFields] = useState([
    //           {
    //             label: 'Working Days',
    //             type: 'multiDropdown',
    //             value: [],
    //             options: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map(d => ({ label: d, value: d }))
    //           },
    //           {
    //             label: 'Office Working Hours',
    //             type: 'timeDropdown',
    //             value: { start: '', end: '' },
    //           },
    //           {
    //             label: 'Week Off',
    //             type: 'multiDropdown',
    //             value: [],
    //             options: [], // Will be populated dynamically
    //           },
    //           {
    //             label: 'Last Working Day of the Month',
    //             type: 'date',
    //             value: '',
    //             isMandatory: true,
    //           },
    //           { label: 'No. of Casual Leaves', type: 'number', value:'' },
    //           { label: 'No. of Sick Leaves', type: 'number', value: '' },
    //           { label: 'No. of Sandwich Leaves', type: 'number', value: '' },
    //           { label: 'Present Days', type: 'number', value: '' },
    //           { label: 'No. of Loss of Pay', type: 'number', value: '' },
    //           { label: 'Location', type: 'text', value: '' },
    //           { label: 'In Time', type: 'text', value: '' },
    //           { label: 'Out Time', type: 'text', value: '' },
    //           { label: 'Break Time', type: 'text', value: '' },
    //         ]);

            const [fields, setFields] = useState([
                {
                  key: 'workingDays',
                  label: 'Working Days',
                  type: 'multiDropdown',
                  value: [],
                  options: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map(d => ({ label: d, value: d }))
                },
                {
                  key: 'officeWorkingHours',
                  label: 'Office Working Hours',
                  type: 'timeDropdown',
                  value: { start: '', end: '' }
                },
                {
                  key: 'weekOff',
                  label: 'Week Off',
                  type: 'multiDropdown',
                  value: [],
                  options: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map(d => ({ label: d, value: d }))
                },
                {
                    key: 'lastWorkingDay',
                    label: 'Last Working Day of the Month',
                    type: 'dropdown',
                    value: '',
                    // isMandatory: true,
                    options: Array.from({ length: 31 }, (_, i) => ({
                      label: `${i + 1}`,
                      value: `${i + 1}`
                    }))
                  },
                { key: 'casualLeave', label: 'No. of Casual Leaves', type: 'number', value: '' },
                { key: 'sickLeave', label: 'No. of Sick Leaves', type: 'number', value: '' },
                { key: 'sandwichLeave', label: 'No. of Sandwich Leaves', type: 'number', value: '' },
                { key: 'presentDays', label: 'Present Days', type: 'number', value: '' },
                { key: 'lossOfPay', label: 'No. of Loss of Pay', type: 'number', value: '' },
                { key: 'location', label: 'Location', type: 'text', value: '' },
                { key: 'inTime', label: 'In Time', type: 'text', value: '' },
                { key: 'outTime', label: 'Out Time', type: 'text', value: '' },
                { key: 'breakTime', label: 'Break Time', type: 'text', value: '' },
              ]);
              

            const handleChange = (index, type, newValue) => {
                const updatedFields = [...fields];
              
                if (type === 'time') {
                  updatedFields[index].value = { ...updatedFields[index].value, ...newValue };
                } else if (type === 'multiDropdown') {
                  // Validate format to prevent primitive strings
                  const validatedValue = Array.isArray(newValue)
                    ? newValue.filter(val => val && typeof val === 'object' && val.label && val.value)
                    : [];
              
                  updatedFields[index].value = validatedValue;

                  if (updatedFields[index].key === 'weekOff') {
                    const weekOffValues = validatedValue.map(v => v.value);
                    const allDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

                    const newWorkingDaysOptions = allDays
                      .filter(day => !weekOffValues.includes(day))
                      .map(day => ({ label: day, value: day }));

                    const workingDaysIndex = updatedFields.findIndex(f => f.key === 'workingDays');
                    if (workingDaysIndex !== -1) {
                      // Remove any working day that is now a week off
                      const currentWorkingDays = updatedFields[workingDaysIndex].value;
                      const filteredWorkingDays = currentWorkingDays.filter(day => !weekOffValues.includes(day.value));

                      updatedFields[workingDaysIndex].options = newWorkingDaysOptions;
                      updatedFields[workingDaysIndex].value = filteredWorkingDays;
                    }
                  }
                } else {
                  updatedFields[index].value = newValue;
                }
              
                setFields(updatedFields);
              };

              const validateFields1 = () => {
                const newErrors = {};
            
                // Validate Working Days
                const workingDaysField = fields.find((f) => f.label === 'Working Days');
                if (!workingDaysField?.value?.length) {
                  newErrors.workingDays = 'Please select working days.';
                }
            
                // Validate Office Working Hours
                const officeWorkingHoursField = fields.find((f) => f.label === 'Office Working Hours');
                if (!officeWorkingHoursField?.value?.start || !officeWorkingHoursField?.value?.end) {
                  newErrors.officeWorkingHours = 'Please select office working hours.';
                }
            
                // Validate Week Off
                const weekOffField = fields.find((f) => f.label === 'Week Off');
                if (!weekOffField?.value?.length) {
                  newErrors.weekOff = 'Please select week off days.';
                }
            
                // Validate Last Working Day of the Month
                const lastWorkingDayField = fields.find((f) => f.label === 'Last Working Day of the Month');
                if (!lastWorkingDayField?.value) {
                  newErrors.lastWorkingDay = 'Please select the last working day of the month.';
                }
            
                // Validate numbers for Casual, Sick, Sandwich Leaves, etc.
                const numberValidation = (value) => /^[0-9]+$/.test(value);
                const casualLeaveField = fields.find((f) => f.label === 'No. of Casual Leaves');
                const sickLeaveField = fields.find((f) => f.label === 'No. of Sick Leaves');
                const sandwichLeaveField = fields.find((f) => f.label === 'No. of Sandwich Leaves');
                const presentDaysField = fields.find((f) => f.label === 'Present Days');
                const lossOfPayField = fields.find((f) => f.label === 'No. of Loss of Pay');
            
                if (casualLeaveField?.value && !numberValidation(casualLeaveField?.value)) {
                  newErrors.casualLeave = 'Casual Leave must be a valid number.';
                }
                if (sickLeaveField?.value && !numberValidation(sickLeaveField?.value)) {
                  newErrors.sickLeave = 'Sick Leave must be a valid number.';
                }
                if (sandwichLeaveField?.value && !numberValidation(sandwichLeaveField?.value)) {
                  newErrors.sandwichLeave = 'Sandwich Leave must be a valid number.';
                }
                if (presentDaysField?.value && !numberValidation(presentDaysField?.value)) {
                  newErrors.presentDays = 'Present Days must be a valid number.';
                }
                if (lossOfPayField?.value && !numberValidation(lossOfPayField?.value)) {
                  newErrors.lossOfPay = 'Loss of Pay must be a valid number.';
                }
            
                // Validate alphanumeric fields: In Time, Out Time, Break Time
                const inTimeField = fields.find((f) => f.label === 'In Time');
                const outTimeField = fields.find((f) => f.label === 'Out Time');
                const breakTimeField = fields.find((f) => f.label === 'Break Time');
            
                const alphanumericValidation = (value) => /^[a-zA-Z0-9\s:]+$/.test(value);
            
                if (inTimeField?.value && !alphanumericValidation(inTimeField?.value)) {
                  newErrors.inTime = 'In Time contains invalid characters.';
                }
                if (outTimeField?.value && !alphanumericValidation(outTimeField?.value)) {
                  newErrors.outTime = 'Out Time contains invalid characters.';
                }
                if (breakTimeField?.value && !alphanumericValidation(breakTimeField?.value)) {
                  newErrors.breakTime = 'Break Time contains invalid characters.';
                }
            
                // Expiry date validation
                const expiryDateField = fields.find((f) => f.label === 'Expiry Date');
                const startDateField = fields.find((f) => f.label === 'Start Date');
                if (expiryDateField?.value && expiryDateField?.value < startDateField?.value) {
                  newErrors.expiryDate = "Expiry date can't be before start date.";
                }
            
                // If there are errors, update the state
                setErrors(newErrors);
                return Object.keys(newErrors).length === 0; // Returns true if no errors
              };

              const validateFields = () => {
                const newErrors = {};
              
                const getField = (key) => fields.find((f) => f.key === key);
              
                // Validate Working Days
                const workingDaysField = getField('workingDays');
                if (!workingDaysField?.value?.length) {
                  newErrors.workingDays = 'Please select working days.';
                }
              
                // Validate Office Working Hours
                const officeWorkingHoursField = getField('officeWorkingHours');
                if (!officeWorkingHoursField?.value?.start || !officeWorkingHoursField?.value?.end) {
                  newErrors.officeWorkingHours = 'Please select office working hours.';
                }
              
                // Validate Week Off
                const weekOffField = getField('weekOff');
                if (!weekOffField?.value?.length) {
                  newErrors.weekOff = 'Please select week off days.';
                }
              
                // Validate Last Working Day of the Month
                const lastWorkingDayField = getField('lastWorkingDay');
                if (!lastWorkingDayField?.value) {
                  newErrors.lastWorkingDay = 'Please select the last working day of the month.';
                }
              
                // Validate numbers for Casual, Sick, Sandwich Leaves, etc.
                const numberValidation = (value) => /^[0-9]+$/.test(value);
                const keysToValidateAsNumbers = ['casualLeave', 'sickLeave', 'sandwichLeave', 'presentDays', 'lossOfPay'];
              
                keysToValidateAsNumbers.forEach((key) => {
                  const field = getField(key);
                  if (field?.value && !numberValidation(field.value)) {
                    newErrors[key] = `${field?.label} must be a valid number.`;
                  }
                });
              
                // Validate alphanumeric fields: In Time, Out Time, Break Time
                const alphanumericValidation = (value) => /^[a-zA-Z0-9\s:]+$/.test(value);
                const timeFields = ['location','inTime', 'outTime', 'breakTime'];
              
                timeFields.forEach((key) => {
                  const field = getField(key);
                  if (field?.value && !alphanumericValidation(field.value)) {
                    newErrors[key] = `${field?.label} contains invalid characters.`;
                  }
                });
              
                // Example: Expiry Date logic (remove or adapt as needed)
                const expiryDateField = getField('expiryDate');
                const startDateField = getField('startDate');
                if (expiryDateField?.value && startDateField?.value && expiryDateField.value < startDateField.value) {
                  newErrors.expiryDate = "Expiry date can't be before start date.";
                }
              
                // Set errors and return
                setErrors(newErrors);
                return Object.keys(newErrors).length === 0;
              };
              
              const clearFields = () => {
                const allDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                const defaultDayOptions = allDays.map(day => ({ label: day, value: day }));
                const cleared = fields.map((field) => {
                  let clearedValue = '';
              
                  if (field.type === 'multiDropdown') {
                    clearedValue = [];
                  } else if (field.type === 'timeDropdown') {
                    clearedValue = { start: '', end: '' };
                  }

                  // ✅ Reset options for workingDays and weekOff
                  if (field.key === 'workingDays' || field.key === 'weekOff') {
                    return {
                      ...field,
                      value: clearedValue,
                      options: defaultDayOptions
                    };
                  }
              
                  return { ...field, value: clearedValue };
                });
              
                setFields(cleared);
                setErrors({}); // Also clear validation errors if needed
              };
              

              const [leaveConfigurationLoading, setLeaveConfigurationLoading] = useState(false)
              const [leaveConfigurationError,setLeaveConfigurationError ] = useState('')
              const [leaveConfigurationSuccess, setLeaveConfigurationSuccess] = useState('')
              const handleAddLeaveConfiguration = async () => {
                try {
                    setLeaveConfigurationError('')
                    setLeaveConfigurationSuccess('')
                  // Reset all error states first
                  if (!validateFields()) {
                    return;
                    }
              
                  // Set loading state
                  setLeaveConfigurationLoading(true);
              
                  // Retrieve user information (e.g., emp_id)
                  const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
                  const isUpdate = leaveConfigurationsList?.[0]?.setting_id ? true : false;
                  // Constructing payload for the API call
                  const payload = {
                    emp_id_auth : storedUserInfo?.emp_id,
                    "action_type": "leave_config_add",
                    working_days: fields.find((f) => f.label === 'Working Days')?.value,
                    office_hours: {
                      start: fields.find((f) => f.label === 'Office Working Hours')?.value.start,
                      end: fields.find((f) => f.label === 'Office Working Hours')?.value.end,
                    },
                    week_off: fields.find((f) => f.label === 'Week Off')?.value,
                    last_working_day: parseInt(fields.find((f) => f.label === 'Last Working Day of the Month')?.value?.value),
                    casual_leave: fields.find((f) => f.label === 'No. of Casual Leaves')?.value,
                    sick_leave: fields.find((f) => f.label === 'No. of Sick Leaves')?.value,
                    sandwich_leave: fields.find((f) => f.label === 'No. of Sandwich Leaves')?.value,
                    present_days: fields.find((f) => f.label === 'Present Days')?.value,
                    loss_of_pay: fields.find((f) => f.label === 'No. of Loss of Pay')?.value,
                    location: fields.find((f) => f.label === 'Location')?.value,
                    in_time: fields.find((f) => f.label === 'In Time')?.value,
                    out_time: fields.find((f) => f.label === 'Out Time')?.value,
                    break_time: fields.find((f) => f.label === 'Break Time')?.value,
                    expiry_date: fields.find((f) => f.label === 'Expiry Date')?.value,
                  };

                  if (isUpdate) {
                    payload.action_type = "leave_config_update";
                    payload.setting_id = leaveConfigurationsList?.[0]?.setting_id;
                  }
              
                  console.log('Payload for Leave Configuration:', payload);
                //   return
              
                  // Make the API call
                  const response = await postData(ORG_LEAVE_CONFIGURATIONS, payload);
                  const responseData = await response.json();
              
                  // Check for success (200) and internal status code
                  if (response?.status === 200) {
                    if (responseData?.statusCode === 200) {
                      if (responseData?.message.toLowerCase() === 'success') {
                        setLeaveConfigurationSuccess(responseData?.info);
                        setTimeout(() => {
                        setLeaveConfigurationSuccess('')
                        clearFields();
                        onRefresh()
                        }, 3000);
                      } else {
                        setLeaveConfigurationError(responseData?.info || 'Failed to save leave configuration. Please try again.');
                        logFrontendException(storedUserId, pageName, "handleAddLeaveConfiguration", responseData?.info || '');
                      }
                    } else {
                      setLeaveConfigurationError(responseData?.info || 'Failed to save leave configuration.');
                      logFrontendException(storedUserId, pageName, "handleAddLeaveConfiguration", responseData?.info || '');
                    }
                  }
                  // Token-related errors: 400, 401, 403
                  else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                      setLeaveConfigurationError('Unauthorized access. Your session may have expired. Please log in again.');
                      logFrontendException(storedUserId, pageName, "handleAddLeaveConfiguration", responseData || '');
                    setIsLoginPopup(true)
                  }
                  else {
                    setLeaveConfigurationError('Error occurred while saving leave configuration.');
                    logFrontendException(storedUserId, pageName, "handleAddLeaveConfiguration", response || '');
                  }
                } catch (error) {
                    setLeaveConfigurationError(`Failed to save leave configuration. Please check your network connection and try again.`);
                    logFrontendException(storedUserId, pageName, "handleAddLeaveConfigurationCatch", error || '');
                } finally {
                  setLeaveConfigurationLoading(false);
                }
              };
              

    return {
        handleChange,
        timeOptions,
        setFields,
        fields,
        handleAddLeaveConfiguration,
        leaveConfigurationSuccess,
        leaveConfigurationError,
        leaveConfigurationLoading,
        errors,
        clearFields
    }

}
export default LeaveConfigurationController;